var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"beschreibung-tooltip p-2 mt-4 rounded border d-flex justify-content-center",style:({ backgroundColor: _vm.color })},[_c('span',{domProps:{"innerHTML":_vm._s(this.params.value)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }